/**
 * 任务管理存本地DB
 */

import Dexie from 'dexie';
import { TaskId, TaskInDB, TableName, UserInfo } from './types';

type Table = Dexie.Table<TaskInDB, TaskId>;

class TaskDB {
  private db: Dexie = new Dexie('TaskManager');

  private tables = {
    // 只存2个table
    uploadTable: {},
    downloadTable: {},
  };

  public async init() {
    // 建表 建主键taskId
    const table = {
      uploadTable: '&taskId, [userId+orgId], taskInfo',
      downloadTable: '&taskId, [userId+orgId], taskInfo',
    };

    this.db.version(2).stores(table);

    this.tables.uploadTable = this.db.table('uploadTable');
    this.tables.downloadTable = this.db.table('downloadTable');

    await this.open();
  }

  private open() {
    return new Promise((resolve, reject) => {
      if (this.db.isOpen()) {
        resolve(this);
        return;
      }
      this.db
        .open()
        .then(() => {
          resolve(this);
          logger.ui('[transmissionDBManager] 腾讯云企业网盘 TaskManager数据库打开成功...');
        })
        .catch(err => {
          logger.ui.error('[transmissionDBManager] 腾讯云企业网盘 TaskManager数据库打开失败', JSON.stringify(err));
        });
    });
  }

  // 获取表名
  private getTableByName(tableName: TableName) {
    const table: Table = this.tables[tableName] as Table;
    return table;
  }

  // 获取当前用户当前企业的列表
  public getList(tableName: TableName, { userId, orgId }: UserInfo) {
    const table = this.getTableByName(tableName);
    return table.where({ userId, orgId }).toArray();
  }

  // 新增、更新数据表
  public async put(tableName: TableName, taskId: string, value: any) {
    const table = this.getTableByName(tableName);
    return table.put(value, taskId);
  }

  // 批量更新
  public async bulkPut(tableName: TableName, records: any[]) {
    const table = this.getTableByName(tableName);
    return table.bulkPut(records);
  }

  // 删除数据项
  public async delete(tableName: TableName, { taskId }: { taskId: string }) {
    const table = this.getTableByName(tableName);
    return table.where({ taskId }).delete();
  }

  // 批量删除数据项
  public async bulkDelete(tableName: TableName, keys: string[]) {
    const table = this.getTableByName(tableName);
    return table.bulkDelete(keys);
  }

  // 清空数据项
  public async clear(tableName: TableName, { userId, orgId }: UserInfo) {
    const table = this.getTableByName(tableName);
    await table.where({ userId, orgId }).delete();
  }

  // 清空某用户所有记录
  public async clearByUserId({ userId }: { userId: number }) {
    const tableNames = Object.keys(this.tables);
    const clearTableFn = tableNames.map(item => {
      const tableName: TableName = item as TableName;
      const table: Table = this.tables[tableName] as Table;
      return table.where({ userId }).delete();
    });
    await Promise.all(clearTableFn);
  }

  // 关闭数据库
  public close() {
    this.db.close();
  }
}

const taskDB = new TaskDB();

export default taskDB;
